module.exports = __webpack_public_path__ + "static/media/mama-burger-combo-mobile-en.81f74820.jpg";